import { jsxs as n, jsx as o } from "react/jsx-runtime";
import { Alert as c, Error as s, colors as i, AlertTitle as l } from "@goshippo/components";
const f = ({ children: t, title: r, ...e }) => n(c, { ...e, icon: o(s, { fontSize: "inherit" }), severity: "info", sx: {
  ...e.sx,
  background: i.backgroundDeemphasized,
  "& .MuiAlert-icon": {
    color: i.secondary
  }
}, children: [r && o(l, { children: r }), t] });
export {
  f as default
};
//# sourceMappingURL=index.js.map
